import Vue from 'vue'
import OOP from './OOP'
import OOPToday from './OOPToday'
import OOPTodaySC from './OOPTodaySC'
import Draws from './Draws'
import Live from './Live'
import LivePerStadium from './LivePerStadium'
import LiveCarousel from './LiveCarousel'
import Results from './Results'
import ResultsDay from './ResultsDay'
import ResultsLatest from './ResultsLatest'
import ResultsCarousel from './ResultsCarousel'
import PlayerOOP from './PlayerOOP'
import MatchDetail from './MatchDetail'
import FeaturedMatches from './FeaturedMatches'
import PlayerResults from './PlayerResults'
import PlayerLive from './PlayerLive'

if ( jQuery('#game').length > 0) {

    let app = new Vue({
        components: {
            'score-oop'              : OOP,
            'score-oop-today'        : OOPToday,
            'score-oop-today-sc'     : OOPTodaySC,
            'score-draws'            : Draws,
            'score-live'             : Live,
            'score-live-stadium'     : LivePerStadium,
            'score-live-carousel'    : LiveCarousel,
            'score-results'          : Results,
            'score-results-day'      : ResultsDay,
            'score-results-latest'   : ResultsLatest,
            'score-results-carousel' : ResultsCarousel,
            'score-player-oop'       : PlayerOOP,
            'score-match'            : MatchDetail,
            'score-featured'         : FeaturedMatches,
            'score-player-matches'   : PlayerResults,
            'score-player-live'      : PlayerLive
        },
        el: '#game',
        data: {
        }
    })
}
console.log('got here')
